<div class="container">
  <mat-card>
    <form [formGroup]="accountNumberPreferenceForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Account Type' | translate }}</mat-label>
            <mat-select required formControlName="accountType">
              @for (accountType of accountNumberPreferencesTemplateData.accountTypeOptions; track accountType) {
                <mat-option [value]="accountType.id">
                  {{ accountType.value | translateKey: 'catalogs' }}
                </mat-option>
              }
            </mat-select>
            @if (accountNumberPreferenceForm.controls.accountType.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Account Type' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Prefix Field' | translate }}</mat-label>
            <mat-select formControlName="prefixType">
              @for (prefixType of prefixTypeData; track prefixType) {
                <mat-option [value]="prefixType.id">
                  {{ prefixType.value }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!accountNumberPreferenceForm.valid"
          *LOSxHasPermission="'CREATE_ACCOUNTNUMBERFORMAT'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
